/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.getMessages'

export { $nsid }

const main = l.query(
  $nsid,
  l.params({
    convoId: l.string(),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    messages: l.array(
      l.typedUnion(
        [
          l.typedRef<ConvoDefs.MessageView>(
            (() => ConvoDefs.messageView) as any,
          ),
          l.typedRef<ConvoDefs.DeletedMessageView>(
            (() => ConvoDefs.deletedMessageView) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
